import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CustomFileUploaderComponent} from "./custom-file-uploader.component";
import {CustomIconsModule} from "../../icons/custom-icons.module";
import {I18nModule} from "@spartacus/core";
import {FormErrorsModule} from "@spartacus/storefront";
import {ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [CustomFileUploaderComponent],
  exports: [
    CustomFileUploaderComponent
  ],
  imports: [
    CommonModule,
    CustomIconsModule,
    I18nModule,
    FormErrorsModule,
    ReactiveFormsModule
  ]
})
export class CustomFileUploaderModule { }
